// src/pages/OpenAppRedirect.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// const OpenAppRedirect = ({ paths = "" }) => {
//   const location = window.location.pathname;
//   // const path = window.location.pathname;
//   console.log('location', window.location.href);
//   //   {
//   //     "pathname": "/openapp",
//   //     "search": "",
//   //     "hash": "",
//   //     "state": null,
//   //     "key": "default"
//   // }

//   useEffect(() => {
//     if (currentPath.includes('/openapp')) {
//       console.log(paths, "OpenAppRedirect path");
//       if (navigator?.userAgent?.match(/Android/i)) {
//         // window.location.href = "https://play.google.com/store/apps/details?id=com.ipo.trend";
//       } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
//         window.location.href = `applink://${window?.location?.href}`;
//       } else {
//         // window.location.href = "https://apps.apple.com/app/id6738792695";
//       }

//       // const cleanedUrl = window.location.href.replace(paths.replace("openapp", ""));
//       const cleanedUrl = window?.location?.href?.replace(paths);
//       setTimeout(() => {
//         window?.location?.replace(cleanedUrl);
//       }, 2000);
//     }

//     // const currentPath = window.location.pathname;

//     // if (currentPath.includes('/openapp')) {
//     //   // Remove '/openapp' from the path
//     //   const cleanedPath = currentPath.replace('/openapp', '');
//     //   const cleanedUrl = `${window.location.origin}${cleanedPath}`;

//     //   // Detect the user's device
//     //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;

//     //   if (/android/i.test(userAgent)) {
//     //     // Redirect to Android app
//     //     window.location.href = 'https://play.google.com/store/apps/details?id=com.ipo.trend';
//     //   } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
//     //     // Redirect to iOS app
//     //     window.location.href = `applink://${cleanedUrl}`;
//     //   } else {
//     //     // For other devices or fallback
//     //     window.location.href = cleanedUrl;
//     //   }
//     // }

//   }, [location]);

//   return (
//     <div style={{ textAlign: "center", marginTop: "50px" }}>
//       <h2>Opening App...</h2>
//     </div>
//   );
// };

const OpenAppRedirect = ({ paths = "" }) => {

  const location = useLocation();


  var finalRedirectUrl = '';

  useEffect(() => {
    if (paths?.includes('/openapp')) {

      // if (navigator.userAgent.match(/Android/i)) {
      //   // window.location.href = "https://play.google.com/store/apps/details?id=com.ipo.trend";
      // } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      //   window.location.href = `applink://${window.location.href}`;
      // } else {
      //   // window.location.href = "https://apps.apple.com/app/id6738792695";
      // }

      // (navigator.userAgent.match(/iPhone|iPad|iPod/i))
      if (navigator.userAgent.match(/Android/i)) {
        // Example: Use intent or Play Store link
        finalRedirectUrl = "https://play.google.com/store/apps/details?id=com.ipopulse.trend";
      } else {

        finalRedirectUrl = `applink://https://ipo-trend.com${paths}`;
      }

      //  else if (navigator.userAgent.match(/Windows/i)) {

      //   finalRedirectUrl = paths?.replace('/openapp', '');
      // } else {

      //   finalRedirectUrl = paths?.replace('/openapp', '');
      // }

      window.location.href = `${finalRedirectUrl?.replace('/openapp', '')}`;

      console.log('finalRedirectUrl', finalRedirectUrl);

      const cleanedUrl = paths?.replace('/openapp', '');

      console.log('OpenAppRedirect cleanedUrl', cleanedUrl);

      setTimeout(() => {
        window.location.href = cleanedUrl;
      }, 2000);

    }
  }, [paths]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Opening App... {finalRedirectUrl}</h2>
    </div>
  );
};


export default OpenAppRedirect;
